import { type MutationOptions, useRxUpdateMutationById } from '@/hooks/rxdb-base';

import type { Note, Block, UserSource, Instruction } from '@flintmint/core-shared/rxdb';
import type { SearchableDocument } from '@/services/search-service/orama-schema';

export const useSmartUpdate = () => {
  const { mutate: updateNoteById } = useRxUpdateMutationById<Note>('notes');
  const { mutate: updateBlockById } = useRxUpdateMutationById<Block>('blocks');
  const { mutate: updateUserSourceById } = useRxUpdateMutationById<UserSource>('userSources');
  const { mutate: updateInstructionById } = useRxUpdateMutationById<Instruction>('instructions');

  const update = async (
    document: SearchableDocument,
    payload: Partial<Note | Block | UserSource | Instruction>,
    mutationOptions?: MutationOptions
  ) => {
    switch (document.type) {
      case 'notes':
      case 'templates':
        return updateNoteById(document.id, payload as Partial<Note>, mutationOptions);
      case 'blocks':
        return updateBlockById(document.id, payload as Partial<Block>, mutationOptions);
      case 'userSources':
        return updateUserSourceById(document.id, payload as Partial<UserSource>, mutationOptions);
      case 'instructions':
        return updateInstructionById(document.id, payload as Partial<Instruction>, mutationOptions);
      default:
        return Promise.reject(new Error('unsupported type'));
    }
  };

  return { update };
};
